import { createContext, PropsWithChildren, use, useState } from "react";

export enum KeyframeViewer {
  None,
  Cesium,
  PdfTron,
  Pannellum,
}

const SelectedViewerContext =
  createContext<ReturnType<typeof useProvider>>(null);

export const useSelectedViewer = () => use(SelectedViewerContext);

export const SelectedViewerProvider = (p: PropsWithChildren<{}>) => {
  const value = useProvider();
  return (
    <SelectedViewerContext value={value}>{p.children}</SelectedViewerContext>
  );
};

const useProvider = () => {
  const [viewer, setViewer] = useState(KeyframeViewer.Cesium);

  return { viewer, setViewer };
};
